<template>
  <div
    :class="$style.contextMenu"
    :style="{ left: mouseX + 'px', top: mouseY + 'px' }"
  >
    <router-link
      :class="$style.link"
      :to="{
        name: 'advanced',
        query: {
          dateFrom: eventRange.day.from,
          dateTo: eventRange.day.to,
          computer: userId,
          logId,
          filter,
        },
      }"
      target="_blank"
    >
      {{ $t('common.viewInTheEventStream') }}
    </router-link>
  </div>
</template>

<script>
  import dayjs from 'dayjs';
  import utc from 'dayjs/plugin/utc';

  dayjs.extend(utc);

  export default {
    props: ['mouseX', 'mouseY', 'userId', 'logId', 'filter'],
    computed: {
      dateRange() {
        return this.$store.getters['filters/formattedDateRange'];
      },
      eventRange() {
        return {
          day: {
            from: dayjs.utc(this.dateRange.dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            to: dayjs.utc(this.dateRange.dateTo).format('YYYY-MM-DD HH:mm:ss'),
          },
        };
      },
    },
  };
</script>

<style lang="scss" module>
  .contextMenu {
    box-shadow: 4px 6px 14px rgba(165, 165, 165, 0.4);
    position: absolute;
    background-color: white;
    width: 244px;
    z-index: 30;
    padding: 10px;
  }

  .link {
    text-decoration: none;
    display: block;
    padding: 3px;
    color: #4b4b4b;
    font-size: 14px;
    cursor: pointer;

    &:hover {
      background: $borderColor;
    }
  }
</style>
